import { createContext } from 'react';

import type { CanvasContextType } from './shared/types';

export default createContext<CanvasContextType>(null);
